var render = function () {
  var _vm$book, _vm$book2, _vm$book3, _vm$book4, _vm$book5, _vm$book6, _vm$book7, _vm$book8, _vm$book9, _vm$book10, _vm$book11;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container sub_wrap",
    attrs: {
      "id": "container"
    }
  }, [_c('article', {
    staticClass: "content",
    attrs: {
      "id": "content"
    }
  }, [_c('Breadcrumb'), _c('WPageWrapper', {
    attrs: {
      "first-fetch-data-callback": _vm.fetchData
    }
  }, [_c('div', {
    staticClass: "sub_section_wrap book_common_particulars"
  }, [_c('section', {
    staticClass: "page_section"
  }, [_c('div', {
    staticClass: "page_section_inner"
  }, [_c('div', {
    staticClass: "book_particulars_wrap"
  }, [_c('div', {
    staticClass: "book_info_top"
  }, [_c('BookCover', {
    attrs: {
      "img": (_vm$book = _vm.book) === null || _vm$book === void 0 ? void 0 : _vm$book.coverImagePath,
      "alt": (_vm$book2 = _vm.book) === null || _vm$book2 === void 0 ? void 0 : _vm$book2.title,
      "book-size": "book_type4"
    }
  }), _c('div', {
    staticClass: "book_info_details"
  }, [_c('BookInfoTitle', {
    attrs: {
      "title": (_vm$book3 = _vm.book) === null || _vm$book3 === void 0 ? void 0 : _vm$book3.title,
      "book-seq": _vm.bookSeq,
      "series": (_vm$book4 = _vm.book) === null || _vm$book4 === void 0 ? void 0 : _vm$book4.seriesTitle,
      "share-type": "book"
    }
  }), _c('div', {
    staticClass: "book_info_publishing"
  }, [_vm.hasBadge ? _c('div', {
    staticClass: "book_tag_wrap"
  }, [_c('ul', {
    staticClass: "tag_list_wrap type3"
  }, [_vm.book.newest ? _c('li', {
    staticClass: "tag_list_item"
  }, [_c('div', {
    staticClass: "tag_box tag_new"
  }, [_c('span', {
    staticClass: "tag_text"
  }, [_vm._v("New")])])]) : _vm._e(), _vm.book.bestSeller ? _c('li', {
    staticClass: "tag_list_item"
  }, [_c('div', {
    staticClass: "tag_box tag_best"
  }, [_c('span', {
    staticClass: "tag_text"
  }, [_vm._v("Best")])])]) : _vm._e()])]) : _vm._e(), _c('ul', {
    staticClass: "book_publishing"
  }, [_c('BookPublishingItem', {
    attrs: {
      "title": "저자",
      "tag-name": "p"
    }
  }, [_c('BookAuthor', {
    attrs: {
      "authors": _vm.authorsText,
      "author-type": "none"
    }
  })], 1), (_vm$book5 = _vm.book) !== null && _vm$book5 !== void 0 && _vm$book5.publicationDate ? _c('BookPublishingItem', {
    attrs: {
      "title": "출간일"
    }
  }, [_vm._v(" " + _vm._s(_vm._f("date")(_vm.book.publicationDate)) + " ")]) : _vm._e(), (_vm$book6 = _vm.book) !== null && _vm$book6 !== void 0 && _vm$book6.dimension ? _c('BookPublishingItem', {
    attrs: {
      "title": "사양"
    }
  }, [_vm._v(_vm._s(_vm.book.dimension))]) : _vm._e(), _c('BookPublishingItem', {
    attrs: {
      "title": "ISBN"
    }
  }, [_vm._v(_vm._s((_vm$book7 = _vm.book) === null || _vm$book7 === void 0 ? void 0 : _vm$book7.isbn))]), (_vm$book8 = _vm.book) !== null && _vm$book8 !== void 0 && _vm$book8.price ? _c('BookPublishingItem', {
    attrs: {
      "title": "정가"
    }
  }, [_vm._v(" " + _vm._s(_vm._f("price")(_vm.book.price)) + " ")]) : _vm._e(), (_vm$book9 = _vm.book) !== null && _vm$book9 !== void 0 && _vm$book9.stores.length ? _c('BookPublishingItem', {
    attrs: {
      "title": "구매처"
    }
  }, [_c('BookStoreTagList', {
    attrs: {
      "list": _vm.book.stores
    }
  })], 1) : _vm._e()], 1)])], 1)], 1), _c('BookInfoSummary', {
    attrs: {
      "contents": (_vm$book10 = _vm.book) === null || _vm$book10 === void 0 ? void 0 : _vm$book10.introduction
    }
  }), _c('BookInfoAuthorProfile', {
    attrs: {
      "authors": (_vm$book11 = _vm.book) === null || _vm$book11 === void 0 ? void 0 : _vm$book11.authors
    }
  })], 1)])])])])], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }